import { lazy } from "react";
import { ElementDetails } from "@/lib/types";
import { Sizes, tableSettingsFormSchema } from "./constants";
import { AdvancedTableProps } from "./types";

export const details = {
  name: "AdvancedTable",
  description: "A table with advanced features",
  tags: ["Data"],
  category: "Advanced",
  grid: Sizes,
  setup: lazy(() => import("./Setup").then(m => ({ default: m.Setup }))),
  app: lazy(() => import("./App").then(m => ({ default: m.App }))),
  defaultProps: {
    mapping: {
      ...tableSettingsFormSchema.parse({
        arrayField: "",
        countField: "",
        title: "Custom Table",
        columns: [],
      }),
      requestId: "",
    },
  },
} as ElementDetails<AdvancedTableProps>;
